// =====================================
//
//   Profile Controller
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.controller("ProfileController", ['$scope', '$state', '$timeout', '$rootScope', '$q', 'UserService', 'BusinessMemberService',
    function($scope, $state, $timeout, $rootScope, $q, UserService, BusinessMemberService) {
        
        var saveChange = function() {

            if($scope.isUpdating) {
                return;
            }

            var isError = false;

            $scope.isNewNameEmpty = false;
            $scope.isNewEmailEmpty = false;
            $scope.isEmailFormatError = false;
            $scope.isPhoneFormatError = false;
            $scope.isMobliePhoneEmpty = false;
            $scope.isMobliePhoneFormatError = false;
            $scope.isAddressEmpty = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isInvoiceError = false;
            $scope.isDigitalCitizenCarrierIDEmpty = false;
            $scope.isDigitalCitizenCarrierIDError = false;
            $scope.isMobilePhoneCarrierIDEmpty = false;
            $scope.isMobilePhoneCarrierIDError = false;
            $scope.isLoveCodeEmpty = false;
            $scope.isInvoiceEmpty = false;
            $scope.isCompanyEmpty = false;

            if ($scope.tempUser.name == "") {
                $scope.isNewNameEmpty = true;
                isError = true;
            }

            if (!$scope.tempUser.email) {
                $scope.isNewEmailEmpty = true;
                isError = true;
            } else if (!isEmail($scope.tempUser.email)) {
                $scope.isEmailFormatError = true;
                isError = true;
            }

            if (!isPhone($scope.tempUser.phone)) {
                $scope.isPhoneFormatError = true;
                isError = true;
            }

            if(!$scope.tempUser.mobilephone) {
                // $scope.isMobliePhoneEmpty = true;
                // isError = true;
            } else if (!isPhone($scope.tempUser.mobilephone)) {
                $scope.isMobliePhoneFormatError = true;
                isError = true;
            }

            if(!$scope.tempUser.address) {
                // $scope.isAddressEmpty = true;
                // isError = true;
            }

            if(!$scope.tempUser.postal) {
                // $scope.isPostalEmpty = true;
                // isError = true;
            } if (isNaN($scope.tempUser.postal)) {
                $scope.isPostalError = true;
                isError = true;
            }

            if(!$scope.isBusinessMember) {

                if($scope.tempUser.invoiceType === 'dualCopy' && !$scope.tempUser.isDonate) {

                    if($scope.tempUser.carrierType === 'digitalCitizenCarrier') {

                        if(!$scope.tempUser.digitalCitizenCarrierID) {
                            $scope.isDigitalCitizenCarrierIDEmpty = true;
                            isError = true;
                        } else if(!isDigitalCitizenCarrierID($scope.tempUser.digitalCitizenCarrierID)) {
                            $scope.isDigitalCitizenCarrierIDError = true;
                            isError = true;
                        }
                    }

                    if($scope.tempUser.carrierType === 'mobilePhoneCarrier') {
                        if(!$scope.tempUser.mobilePhoneCarrierID) {
                            $scope.isMobilePhoneCarrierIDEmpty = true;
                            isError = true;
                        } else if(!isMobilePhoneCarrierID($scope.tempUser.mobilePhoneCarrierID)) {
                            $scope.isMobilePhoneCarrierIDError = true;
                            isError = true;
                        }
                    }
                } else if($scope.tempUser.invoiceType === 'dualCopy' && $scope.tempUser.isDonate) {
                    if($scope.form.selectLoveCode.code == '-1' && !$scope.tempUser.loveCode) {
                        $scope.isLoveCodeEmpty = true;
                        isError = true;
                    }
                } else if($scope.tempUser.invoiceType === 'triCopy') {
                    if(!$scope.tempUser.invoice) {
                        $scope.isInvoiceEmpty = true;
                        isError = true;
                    } else if(!isTaxIDNumber($scope.tempUser.invoice)) {
                        $scope.isInvoiceError = true;
                        isError = true;
                    }

                    if(!$scope.tempUser.company) {
                        $scope.isCompanyEmpty = true;
                        isError = true;
                    }
                }
            }

            if (isError) {
                return;
            }

            if($scope.isBusinessMember) {
                updateBusinessUserInfo();
            } else {
                updateUserInfo();
            }
        }

        var updateUserInfo = function() {

            if ($scope.tempUser.email != $scope.user.email) {
                $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                    title: '確定更改電子郵件嗎？',
                    description: '更改後需要認證才能生效',
                    callback: function(result) {
                        if(result) {
                            _updateUserInfo();
                        }
                    }
                });
            } else {
                _updateUserInfo();
            }
        }

        var _updateUserInfo = function() {

            if($scope.tempUser.isDonate) {
                $scope.tempUser.loveCode = $scope.form.selectLoveCode.code == '-1' ? $scope.tempUser.loveCode : $scope.form.selectLoveCode.code;
            }

            $scope.isError = false;
            $scope.isUpdating = true;
            $scope.isMobilepRepeat = false;
            $scope.isEmailRepeat = false;

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '正在更新會員資料',
            });

            UserService.updateUserInfo($scope.tempUser).then(function(result) {

                $scope.user.company = $scope.tempUser.company;
                $scope.user.invoice = $scope.tempUser.invoice;

                if ($scope.tempUser.email != $scope.user.email) {
                    updateUserMail();
                } else {
                    $scope.isUpdating = false;
                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功更新會員資料',
                    });
                }
                
            }, function(error) {
                $scope.isUpdating = false;

                if(error && error.code === 'error.account.mobilephoneRepeat'){
                    $scope.isMobilepRepeat = true;
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '您輸入的手機電話已經有人使用',
                    });
                } else {
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            });
        }

        var updateUserMail = function() {

            var updatemailPromise = UserService.updateEmail($scope.tempUser.email).then(function(result) {
                $scope.isUpdating = false;
                $scope.isSuccessUpdateEmail = true;
                $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                    title: '成功更新會員資料',
                });
            }, function(error) {
                $scope.isUpdating = false;

                if(error && error.code === 'error.account.emailRepeat'){
                    $scope.isEmailRepeat = true;
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '您輸入的電子郵件已經申請過囉',
                    });                    
                } else {
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            });
        }

        var updateBusinessUserInfo = function() {

            $scope.isError = false;
            $scope.isUpdating = true;
            $scope.isMobilepRepeat = false;
            $scope.isEmailRepeat = false;

            BusinessMemberService.updateInfo($scope.tempUser).then(function(result) {

                UserService.reloadInfoByBusinessMember();
                $scope.isUpdating = false;
                $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                    title: '成功更新會員資料',
                });
                
            }, function(error) {
                $scope.isUpdating = false;
                
                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                    title: '系統發生錯誤',
                });
            });
        }

        var resetProfileState = function() {

            $scope.isNewNameEmpty = false;
            $scope.isNewEmailEmpty = false;
            $scope.isEmailFormatError = false;
            $scope.isPhoneFormatError = false;
            $scope.isMobliePhoneEmpty = false;
            $scope.isMobliePhoneFormatError = false;
            $scope.isAddressEmpty = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isInvoiceError = false;
            $scope.isUpdating = false;
            $scope.isError = false;
            $scope.isMobilepRepeat = false;
            $scope.isEmailRepeat = false;
            $scope.isSuccessUpdateEmail = false;
            $scope.isBusinessMember = false;
        }

        var initProfileInfo = function() {

            resetProfileState();

            if($scope.user.membertype == 1 && $scope.user.businessmrscid) {
                $scope.isBusinessMember = true;
            }
        }

        var changeInvoiceTypeAndDonate = function(invoiceType, isDonate) {

            $scope.tempUser.invoiceType = invoiceType;
            $scope.tempUser.isDonate = isDonate;

            if(isDonate) {
                changeCarrierType('memberCarrier');
            }
        }

        var changeCarrierType = function(carrierType) {

            $scope.tempUser.carrierType = carrierType;
        }

        var init = function() {

            UserService.getUserInfo().then(function(result) {
                $scope.user = result;
                $scope.tempUser = shallowCopy(result);
                var lastInvoiceInfo = $scope.tempUser.lastInvoiceInfo[$scope.tempUser.lastInvoiceInfo.length-1];
                angular.extend($scope.tempUser, lastInvoiceInfo);
                if(!$scope.tempUser.invoiceType){
                    $scope.tempUser.invoiceType = 'dualCopy';
                }
                if(!$scope.tempUser.carrierType){
                    $scope.tempUser.carrierType = 'memberCarrier';
                }
                if($scope.tempUser.loveCode) {
                    for(var i = 0; i < $scope.loveCodeList.length; i++) {
                        if($scope.tempUser.loveCode == $scope.loveCodeList[i].code) {
                            $scope.form.selectLoveCode = $scope.loveCodeList[i];
                            break;
                        }
                    }   
                }

                initProfileInfo();
            })
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.user;
        $scope.tempUser;

        $scope.form = {
            selectLoveCode: default_loveCodeList[0],
        };
        
        $scope.isNewNameEmpty = false;
        $scope.isNewEmailEmpty = false;
        $scope.isEmailFormatError = false;
        $scope.isPhoneFormatError = false;
        $scope.isMobliePhoneEmpty = false;
        $scope.isMobliePhoneFormatError = false;
        $scope.isAddressEmpty = false;
        $scope.isPostalEmpty = false;
        $scope.isPostalError = false;
        $scope.isUpdating = false;
        $scope.isError = false;
        $scope.isMobilepRepeat = false;
        $scope.isEmailRepeat = false;
        $scope.isSuccessUpdateEmail = false;
        $scope.isBusinessMember = false;
        $scope.isDigitalCitizenCarrierIDEmpty = false;
        $scope.isDigitalCitizenCarrierIDError = false;
        $scope.isMobilePhoneCarrierIDEmpty = false;
        $scope.isMobilePhoneCarrierIDError = false;
        $scope.isLoveCodeEmpty = false;
        $scope.isInvoiceEmpty = false;
        $scope.isCompanyEmpty = false;
        $scope.loveCodeList = default_loveCodeList;

        //==========================
        //  Methods
        //==========================
        $scope.saveChange = saveChange;
        $scope.changeInvoiceTypeAndDonate = changeInvoiceTypeAndDonate;
        $scope.changeCarrierType = changeCarrierType;

        //==========================
        //  Init
        //==========================
        init();
	}
]);